<div class="flex flex-row flex-1 gap-2 justify-between items-center p-0">
  <a
    [disabled]="disabled"
    (click)="decrement()"
    class="w-5 h-5 leading-none flex items-center justify-center"
    mat-icon-button
    [ngClass]="{
      'bg-gray': disabled,
      'hover:bg-hover hover:text-primary text-white bg-primary': !disabled
    }"
  >
    <mat-icon [icIcon]="icMinus" size="18px"></mat-icon>
  </a>
  <input
    [disabled]="disabled"
    (change)="onInputChange($event)"
    class="w-3/6 min-w-14 text-center"
    type="text"
    inputmode="decimal"
    [ngModel]="quantity"
  />
  <a
    [disabled]="disabled"
    (click)="increment()"
    class="w-5 h-5 leading-none flex items-center justify-center"
    mat-icon-button
    [ngClass]="{
      'bg-gray': disabled,
      'hover:bg-hover hover:text-primary text-white bg-primary': !disabled
    }"
  >
    <mat-icon [icIcon]="icPlus" size="18px"></mat-icon>
  </a>
  <span *ngIf="hint" class="text-xs text-gray-500 whitespace-nowrap">{{ hint }}</span>
</div>
